import { motion } from "framer-motion";

export const HEADSHOT_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_c41e25a4-e0ba-427b-a6b0-799ba869165d/artifacts/7s2y1p2b_image.png";
export const LOGO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_c41e25a4-e0ba-427b-a6b0-799ba869165d/artifacts/d66i1e8o_image.png";

export const WEBINAR_DATE = "THURSDAY, SEPTEMBER 3, 2026";
export const WEBINAR_TIME = "7:00 PM EST";
export const WEBINAR_DURATION = "45 MINUTES";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -30, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ n, text }) => (
  <div className="font-mono-strict text-[11px] tracking-[0.32em] text-[#0162CA] mb-6 uppercase">
    [{n}] — {text}
  </div>
);

export const CtaButton = ({
  children = "✓ RESERVE MY FREE SEAT",
  outline = false,
  onClick,
  testId,
  className = "",
}) => (
  <button
    type="button"
    data-testid={testId}
    data-cursor="cta"
    onClick={onClick || (() => {})}
    className={`${outline ? "cta-outline" : "cta-btn"} ${className}`}
  >
    {children}
  </button>
);

export const NC = ({ label }) => (
  <span className="nc-badge">[NEEDS CONFIRMATION: {label}]</span>
);
